import React from "react";
import {
  StyledSearchBarContainer,
  StyledSearchBarContainerContent,
  StyledSearchBarContent,
} from "./search-bar.styles";
import SearchInput, { SearchChangeEventHandler } from "./search-input";

export interface SearchBarProps {
  onChange: SearchChangeEventHandler;
  brand: string;
}

const SearchBar = ({ brand, onChange }: SearchBarProps) => (
  <StyledSearchBarContainer>
    <StyledSearchBarContainerContent>
      <StyledSearchBarContent>
        <SearchInput brand={brand} onChange={onChange} />
      </StyledSearchBarContent>
    </StyledSearchBarContainerContent>
  </StyledSearchBarContainer>
);

export default React.memo(SearchBar);
